import React from "react";
import { Slider } from "../Slider";
import { Picker } from "../Picker";
import { useCalculator } from "./useCalculator";
import { decode } from "html-entities";
// @TODO
// - Enable this once the currency table is ready
const showPicker = true;
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function formatPriceQuick(priceInCents, currencySymbol) {
    let amount = (priceInCents / 100).toFixed(2);
    if (amount.slice(-3) === ".00") {
        amount = amount.substring(0, amount.length - 3);
    }
    return decode(currencySymbol, { level: "html5" }) + amount;
}
const Calculator = () => {
    const { price, participants, updateParticipants, currency, enabledTiersPricing } = useCalculator();
    return (React.createElement("div", { className: "bg-off-white" },
        React.createElement("div", { className: "pricing-calculator container" },
            React.createElement("div", { className: "row px-4 px-md-0" },
                React.createElement("div", { className: "col-12 d-md-none pt-3" },
                    React.createElement("h2", { className: "sub-heading pb-0" }, "Pricing")),
                React.createElement("div", { className: "col-12 col-md-8 order-2 offset-md-2 pt-0 pb-3 py-md-3  text-center" },
                    React.createElement("h2", { className: "sub-heading d-none d-md-block mt-5" }, "Pricing"),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-6 col-md-4 offset-md-2 d-flex flex-column justify-content-center align-items-center pt-3 pb-4 py-md-5" },
                            React.createElement("input", { min: 0, max: 1000, type: "number", value: participants, onChange: updateParticipants, className: "calculator-participants value border-0 text-center" }),
                            React.createElement("span", { className: "calculator-participants title" }, "Participants")),
                        React.createElement("div", { className: "col-6 col-md-4 d-flex flex-column justify-content-center align-items-center pt-3 pb-4 py-md-5" },
                            React.createElement("span", { className: "calculator-price value" }, numberWithCommas(price)),
                            React.createElement("span", { className: "calculator-price title" },
                                "Total cost (",
                                currency,
                                ")"))),
                    React.createElement(Slider, { min: 5, max: 1000, step: 5, value: participants, onChange: updateParticipants, className: "mb-5" })),
                React.createElement("div", { className: "col-12 order-1 order-md-3 col-md-2" }, showPicker && (React.createElement("div", { className: "pt-3 py-md-5" },
                    React.createElement(Picker, null))))),
            React.createElement("div", { className: "col-12 col-md-8 order-2 offset-md-2 pt-0 pb-3" },
                React.createElement("ul", null,
                    React.createElement("li", null, "Pricing is per mission (up to 92 days / 3 months duration)"),
                    React.createElement("li", null, "Contact us for pricing for larger groups, charities, NPOs and school groups"),
                    React.createElement("li", null, "First 25 participants included in the set-up fee"))),
            enabledTiersPricing.length > 0 && (React.createElement("div", { className: "pricing-row mb-4 mt-4", id: "pricing-explanation" },
                React.createElement("div", { className: "card active" },
                    React.createElement("div", { className: "card-body" },
                        React.createElement("h5", { className: "card-title" }, formatPriceQuick(enabledTiersPricing[0].base, enabledTiersPricing[0].currencySymbol)),
                        React.createElement("div", { className: "card-text-wrap" },
                            React.createElement("p", { className: "card-text" },
                                "(",
                                currency,
                                ") per mission - includes set up fee")),
                        React.createElement("p", { className: "card-text" }, "Up to 25 participants"))),
                enabledTiersPricing.map((value, index) => {
                    if (index >= 3) {
                        // only show the first 4
                        return;
                    }
                    // hacky override for minvalue = 25, without changing the db table mm_group_tiered_pricing as that affects the calculations as well as what is displayed
                    return (React.createElement(React.Fragment, { key: index },
                        React.createElement("span", { className: "plus-icon" }, "+"),
                        React.createElement("div", { className: "card" + (value.numParticipantsInTier !== undefined && value.numParticipantsInTier > 0 ? ' active ' : '') },
                            React.createElement("div", { className: "card-body" },
                                React.createElement("h5", { className: "card-title" }, formatPriceQuick(value.price, value.currencySymbol)),
                                React.createElement("div", { className: "card-text-wrap" },
                                    React.createElement("p", { className: "card-text" },
                                        "(",
                                        currency,
                                        ") per additional participant")),
                                React.createElement("p", { className: "card-text" },
                                    value.minValue == 1 ? 26 : value.minValue,
                                    " - ",
                                    value.maxValue,
                                    " participants")))));
                }))))));
};
export { Calculator };
